import { SvgIconComponent } from "@mui/icons-material";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import ConstructionIcon from "@mui/icons-material/Construction";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import FoundationIcon from "@mui/icons-material/Foundation";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import LandscapeIcon from "@mui/icons-material/Landscape";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import PlumbingIcon from "@mui/icons-material/Plumbing";
import SolarPowerIcon from "@mui/icons-material/SolarPower";

// Frontend-only mapping of root category id -> MUI SvgIcon. Intentionally
// not derived from the `Category` GraphQL type — there is no icon column on
// `categories` today, and adding one was out of scope for the onboarding
// change (would require a DB migration + categories-admin tooling for one
// screen's worth of icons; see design D11).
//
// Keys MUST be root-level category ids. Consumers that render only roots
// (e.g. the onboarding verticals stage) will never see a non-root key;
// DEFAULT_CATEGORY_ICON is the fallback if a new root is added to the
// taxonomy without an icon mapping.
export const DEFAULT_CATEGORY_ICON: SvgIconComponent = CategoryOutlinedIcon;

export const CATEGORY_ICONS: Record<string, SvgIconComponent> = {
  civil_engineering: HomeWorkIcon,
  electrical_engineering: ElectricBoltIcon,
  hvac_and_plumbing: PlumbingIcon,
  landscape_construction: LandscapeIcon,
  other: MoreHorizIcon,
  services: MiscellaneousServicesIcon,
  solar_photovoltaics: SolarPowerIcon,
  specialized_construction: ConstructionIcon,
  structural_construction: FoundationIcon,
};

export function getCategoryIcon(categoryId: string): SvgIconComponent {
  return CATEGORY_ICONS[categoryId] ?? DEFAULT_CATEGORY_ICON;
}
